import {
    PUT_APPLECONFIG_FAILED,
    PUT_APPLECONFIG_LOADING,
    PUT_APPLECONFIG_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
};

export const updateAppleConfigReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {

   

    switch (action.type) {
        case PUT_APPLECONFIG_LOADING:
            return {
                ...state,
                loading: true,
            };
        case PUT_APPLECONFIG_SUCCESS:
            return {
                ...state,
                loading: false,
                MerchantPayment: action.payload,
                status: action.status,
                error: null,
            };
        case PUT_APPLECONFIG_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
            };
       
        default:
            return state;
    }
};




